import { t as tuple } from './types-6f6b2fba.js';
import { x as createCommonjsModule } from './i18n-9ea5877b.js';

const codes = [
	[
		"AF",
		"AFG",
		"004",
		"ISO 3166-2:AF"
	],
	[
		"AL",
		"ALB",
		"008",
		"ISO 3166-2:AL"
	],
	[
		"DZ",
		"DZA",
		"012",
		"ISO 3166-2:DZ"
	],
	[
		"AS",
		"ASM",
		"016",
		"ISO 3166-2:AS"
	],
	[
		"AD",
		"AND",
		"020",
		"ISO 3166-2:AD"
	],
	[
		"AO",
		"AGO",
		"024",
		"ISO 3166-2:AO"
	],
	[
		"AI",
		"AIA",
		"660",
		"ISO 3166-2:AI"
	],
	[
		"AQ",
		"ATA",
		"010",
		"ISO 3166-2:AQ"
	],
	[
		"AG",
		"ATG",
		"028",
		"ISO 3166-2:AG"
	],
	[
		"AR",
		"ARG",
		"032",
		"ISO 3166-2:AR"
	],
	[
		"AM",
		"ARM",
		"051",
		"ISO 3166-2:AM"
	],
	[
		"AW",
		"ABW",
		"533",
		"ISO 3166-2:AW"
	],
	[
		"AU",
		"AUS",
		"036",
		"ISO 3166-2:AU"
	],
	[
		"AT",
		"AUT",
		"040",
		"ISO 3166-2:AT"
	],
	[
		"AZ",
		"AZE",
		"031",
		"ISO 3166-2:AZ"
	],
	[
		"BS",
		"BHS",
		"044",
		"ISO 3166-2:BS"
	],
	[
		"BH",
		"BHR",
		"048",
		"ISO 3166-2:BH"
	],
	[
		"BD",
		"BGD",
		"050",
		"ISO 3166-2:BD"
	],
	[
		"BB",
		"BRB",
		"052",
		"ISO 3166-2:BB"
	],
	[
		"BY",
		"BLR",
		"112",
		"ISO 3166-2:BY"
	],
	[
		"BE",
		"BEL",
		"056",
		"ISO 3166-2:BE"
	],
	[
		"BZ",
		"BLZ",
		"084",
		"ISO 3166-2:BZ"
	],
	[
		"BJ",
		"BEN",
		"204",
		"ISO 3166-2:BJ"
	],
	[
		"BM",
		"BMU",
		"060",
		"ISO 3166-2:BM"
	],
	[
		"BT",
		"BTN",
		"064",
		"ISO 3166-2:BT"
	],
	[
		"BO",
		"BOL",
		"068",
		"ISO 3166-2:BO"
	],
	[
		"BA",
		"BIH",
		"070",
		"ISO 3166-2:BA"
	],
	[
		"BW",
		"BWA",
		"072",
		"ISO 3166-2:BW"
	],
	[
		"BV",
		"BVT",
		"074",
		"ISO 3166-2:BV"
	],
	[
		"BR",
		"BRA",
		"076",
		"ISO 3166-2:BR"
	],
	[
		"IO",
		"IOT",
		"086",
		"ISO 3166-2:IO"
	],
	[
		"BN",
		"BRN",
		"096",
		"ISO 3166-2:BN"
	],
	[
		"BG",
		"BGR",
		"100",
		"ISO 3166-2:BG"
	],
	[
		"BF",
		"BFA",
		"854",
		"ISO 3166-2:BF"
	],
	[
		"BI",
		"BDI",
		"108",
		"ISO 3166-2:BI"
	],
	[
		"KH",
		"KHM",
		"116",
		"ISO 3166-2:KH"
	],
	[
		"CM",
		"CMR",
		"120",
		"ISO 3166-2:CM"
	],
	[
		"CA",
		"CAN",
		"124",
		"ISO 3166-2:CA"
	],
	[
		"CV",
		"CPV",
		"132",
		"ISO 3166-2:CV"
	],
	[
		"KY",
		"CYM",
		"136",
		"ISO 3166-2:KY"
	],
	[
		"CF",
		"CAF",
		"140",
		"ISO 3166-2:CF"
	],
	[
		"TD",
		"TCD",
		"148",
		"ISO 3166-2:TD"
	],
	[
		"CL",
		"CHL",
		"152",
		"ISO 3166-2:CL"
	],
	[
		"CN",
		"CHN",
		"156",
		"ISO 3166-2:CN"
	],
	[
		"CX",
		"CXR",
		"162",
		"ISO 3166-2:CX"
	],
	[
		"CC",
		"CCK",
		"166",
		"ISO 3166-2:CC"
	],
	[
		"CO",
		"COL",
		"170",
		"ISO 3166-2:CO"
	],
	[
		"KM",
		"COM",
		"174",
		"ISO 3166-2:KM"
	],
	[
		"CG",
		"COG",
		"178",
		"ISO 3166-2:CG"
	],
	[
		"CD",
		"COD",
		"180",
		"ISO 3166-2:CD"
	],
	[
		"CK",
		"COK",
		"184",
		"ISO 3166-2:CK"
	],
	[
		"CR",
		"CRI",
		"188",
		"ISO 3166-2:CR"
	],
	[
		"CI",
		"CIV",
		"384",
		"ISO 3166-2:CI"
	],
	[
		"HR",
		"HRV",
		"191",
		"ISO 3166-2:HR"
	],
	[
		"CU",
		"CUB",
		"192",
		"ISO 3166-2:CU"
	],
	[
		"CY",
		"CYP",
		"196",
		"ISO 3166-2:CY"
	],
	[
		"CZ",
		"CZE",
		"203",
		"ISO 3166-2:CZ"
	],
	[
		"DK",
		"DNK",
		"208",
		"ISO 3166-2:DK"
	],
	[
		"DJ",
		"DJI",
		"262",
		"ISO 3166-2:DJ"
	],
	[
		"DM",
		"DMA",
		"212",
		"ISO 3166-2:DM"
	],
	[
		"DO",
		"DOM",
		"214",
		"ISO 3166-2:DO"
	],
	[
		"EC",
		"ECU",
		"218",
		"ISO 3166-2:EC"
	],
	[
		"EG",
		"EGY",
		"818",
		"ISO 3166-2:EG"
	],
	[
		"SV",
		"SLV",
		"222",
		"ISO 3166-2:SV"
	],
	[
		"GQ",
		"GNQ",
		"226",
		"ISO 3166-2:GQ"
	],
	[
		"ER",
		"ERI",
		"232",
		"ISO 3166-2:ER"
	],
	[
		"EE",
		"EST",
		"233",
		"ISO 3166-2:EE"
	],
	[
		"ET",
		"ETH",
		"231",
		"ISO 3166-2:ET"
	],
	[
		"FK",
		"FLK",
		"238",
		"ISO 3166-2:FK"
	],
	[
		"FO",
		"FRO",
		"234",
		"ISO 3166-2:FO"
	],
	[
		"FJ",
		"FJI",
		"242",
		"ISO 3166-2:FJ"
	],
	[
		"FI",
		"FIN",
		"246",
		"ISO 3166-2:FI"
	],
	[
		"FR",
		"FRA",
		"250",
		"ISO 3166-2:FR"
	],
	[
		"GF",
		"GUF",
		"254",
		"ISO 3166-2:GF"
	],
	[
		"PF",
		"PYF",
		"258",
		"ISO 3166-2:PF"
	],
	[
		"TF",
		"ATF",
		"260",
		"ISO 3166-2:TF"
	],
	[
		"GA",
		"GAB",
		"266",
		"ISO 3166-2:GA"
	],
	[
		"GM",
		"GMB",
		"270",
		"ISO 3166-2:GM"
	],
	[
		"GE",
		"GEO",
		"268",
		"ISO 3166-2:GE"
	],
	[
		"DE",
		"DEU",
		"276",
		"ISO 3166-2:DE"
	],
	[
		"GH",
		"GHA",
		"288",
		"ISO 3166-2:GH"
	],
	[
		"GI",
		"GIB",
		"292",
		"ISO 3166-2:GI"
	],
	[
		"GR",
		"GRC",
		"300",
		"ISO 3166-2:GR"
	],
	[
		"GL",
		"GRL",
		"304",
		"ISO 3166-2:GL"
	],
	[
		"GD",
		"GRD",
		"308",
		"ISO 3166-2:GD"
	],
	[
		"GP",
		"GLP",
		"312",
		"ISO 3166-2:GP"
	],
	[
		"GU",
		"GUM",
		"316",
		"ISO 3166-2:GU"
	],
	[
		"GT",
		"GTM",
		"320",
		"ISO 3166-2:GT"
	],
	[
		"GN",
		"GIN",
		"324",
		"ISO 3166-2:GN"
	],
	[
		"GW",
		"GNB",
		"624",
		"ISO 3166-2:GW"
	],
	[
		"GY",
		"GUY",
		"328",
		"ISO 3166-2:GY"
	],
	[
		"HT",
		"HTI",
		"332",
		"ISO 3166-2:HT"
	],
	[
		"HM",
		"HMD",
		"334",
		"ISO 3166-2:HM"
	],
	[
		"VA",
		"VAT",
		"336",
		"ISO 3166-2:VA"
	],
	[
		"HN",
		"HND",
		"340",
		"ISO 3166-2:HN"
	],
	[
		"HK",
		"HKG",
		"344",
		"ISO 3166-2:HK"
	],
	[
		"HU",
		"HUN",
		"348",
		"ISO 3166-2:HU"
	],
	[
		"IS",
		"ISL",
		"352",
		"ISO 3166-2:IS"
	],
	[
		"IN",
		"IND",
		"356",
		"ISO 3166-2:IN"
	],
	[
		"ID",
		"IDN",
		"360",
		"ISO 3166-2:ID"
	],
	[
		"IR",
		"IRN",
		"364",
		"ISO 3166-2:IR"
	],
	[
		"IQ",
		"IRQ",
		"368",
		"ISO 3166-2:IQ"
	],
	[
		"IE",
		"IRL",
		"372",
		"ISO 3166-2:IE"
	],
	[
		"IL",
		"ISR",
		"376",
		"ISO 3166-2:IL"
	],
	[
		"IT",
		"ITA",
		"380",
		"ISO 3166-2:IT"
	],
	[
		"JM",
		"JAM",
		"388",
		"ISO 3166-2:JM"
	],
	[
		"JP",
		"JPN",
		"392",
		"ISO 3166-2:JP"
	],
	[
		"JO",
		"JOR",
		"400",
		"ISO 3166-2:JO"
	],
	[
		"KZ",
		"KAZ",
		"398",
		"ISO 3166-2:KZ"
	],
	[
		"KE",
		"KEN",
		"404",
		"ISO 3166-2:KE"
	],
	[
		"KI",
		"KIR",
		"296",
		"ISO 3166-2:KI"
	],
	[
		"KP",
		"PRK",
		"408",
		"ISO 3166-2:KP"
	],
	[
		"KR",
		"KOR",
		"410",
		"ISO 3166-2:KR"
	],
	[
		"KW",
		"KWT",
		"414",
		"ISO 3166-2:KW"
	],
	[
		"KG",
		"KGZ",
		"417",
		"ISO 3166-2:KG"
	],
	[
		"LA",
		"LAO",
		"418",
		"ISO 3166-2:LA"
	],
	[
		"LV",
		"LVA",
		"428",
		"ISO 3166-2:LV"
	],
	[
		"LB",
		"LBN",
		"422",
		"ISO 3166-2:LB"
	],
	[
		"LS",
		"LSO",
		"426",
		"ISO 3166-2:LS"
	],
	[
		"LR",
		"LBR",
		"430",
		"ISO 3166-2:LR"
	],
	[
		"LY",
		"LBY",
		"434",
		"ISO 3166-2:LY"
	],
	[
		"LI",
		"LIE",
		"438",
		"ISO 3166-2:LI"
	],
	[
		"LT",
		"LTU",
		"440",
		"ISO 3166-2:LT"
	],
	[
		"LU",
		"LUX",
		"442",
		"ISO 3166-2:LU"
	],
	[
		"MO",
		"MAC",
		"446",
		"ISO 3166-2:MO"
	],
	[
		"MG",
		"MDG",
		"450",
		"ISO 3166-2:MG"
	],
	[
		"MW",
		"MWI",
		"454",
		"ISO 3166-2:MW"
	],
	[
		"MY",
		"MYS",
		"458",
		"ISO 3166-2:MY"
	],
	[
		"MV",
		"MDV",
		"462",
		"ISO 3166-2:MV"
	],
	[
		"ML",
		"MLI",
		"466",
		"ISO 3166-2:ML"
	],
	[
		"MT",
		"MLT",
		"470",
		"ISO 3166-2:MT"
	],
	[
		"MH",
		"MHL",
		"584",
		"ISO 3166-2:MH"
	],
	[
		"MQ",
		"MTQ",
		"474",
		"ISO 3166-2:MQ"
	],
	[
		"MR",
		"MRT",
		"478",
		"ISO 3166-2:MR"
	],
	[
		"MU",
		"MUS",
		"480",
		"ISO 3166-2:MU"
	],
	[
		"YT",
		"MYT",
		"175",
		"ISO 3166-2:YT"
	],
	[
		"MX",
		"MEX",
		"484",
		"ISO 3166-2:MX"
	],
	[
		"FM",
		"FSM",
		"583",
		"ISO 3166-2:FM"
	],
	[
		"MD",
		"MDA",
		"498",
		"ISO 3166-2:MD"
	],
	[
		"MC",
		"MCO",
		"492",
		"ISO 3166-2:MC"
	],
	[
		"MN",
		"MNG",
		"496",
		"ISO 3166-2:MN"
	],
	[
		"MS",
		"MSR",
		"500",
		"ISO 3166-2:MS"
	],
	[
		"MA",
		"MAR",
		"504",
		"ISO 3166-2:MA"
	],
	[
		"MZ",
		"MOZ",
		"508",
		"ISO 3166-2:MZ"
	],
	[
		"MM",
		"MMR",
		"104",
		"ISO 3166-2:MM"
	],
	[
		"NA",
		"NAM",
		"516",
		"ISO 3166-2:NA"
	],
	[
		"NR",
		"NRU",
		"520",
		"ISO 3166-2:NR"
	],
	[
		"NP",
		"NPL",
		"524",
		"ISO 3166-2:NP"
	],
	[
		"NL",
		"NLD",
		"528",
		"ISO 3166-2:NL"
	],
	[
		"NC",
		"NCL",
		"540",
		"ISO 3166-2:NC"
	],
	[
		"NZ",
		"NZL",
		"554",
		"ISO 3166-2:NZ"
	],
	[
		"NI",
		"NIC",
		"558",
		"ISO 3166-2:NI"
	],
	[
		"NE",
		"NER",
		"562",
		"ISO 3166-2:NE"
	],
	[
		"NG",
		"NGA",
		"566",
		"ISO 3166-2:NG"
	],
	[
		"NU",
		"NIU",
		"570",
		"ISO 3166-2:NU"
	],
	[
		"NF",
		"NFK",
		"574",
		"ISO 3166-2:NF"
	],
	[
		"MP",
		"MNP",
		"580",
		"ISO 3166-2:MP"
	],
	[
		"MK",
		"MKD",
		"807",
		"ISO 3166-2:MK"
	],
	[
		"NO",
		"NOR",
		"578",
		"ISO 3166-2:NO"
	],
	[
		"OM",
		"OMN",
		"512",
		"ISO 3166-2:OM"
	],
	[
		"PK",
		"PAK",
		"586",
		"ISO 3166-2:PK"
	],
	[
		"PW",
		"PLW",
		"585",
		"ISO 3166-2:PW"
	],
	[
		"PS",
		"PSE",
		"275",
		"ISO 3166-2:PS"
	],
	[
		"PA",
		"PAN",
		"591",
		"ISO 3166-2:PA"
	],
	[
		"PG",
		"PNG",
		"598",
		"ISO 3166-2:PG"
	],
	[
		"PY",
		"PRY",
		"600",
		"ISO 3166-2:PY"
	],
	[
		"PE",
		"PER",
		"604",
		"ISO 3166-2:PE"
	],
	[
		"PH",
		"PHL",
		"608",
		"ISO 3166-2:PH"
	],
	[
		"PN",
		"PCN",
		"612",
		"ISO 3166-2:PN"
	],
	[
		"PL",
		"POL",
		"616",
		"ISO 3166-2:PL"
	],
	[
		"PT",
		"PRT",
		"620",
		"ISO 3166-2:PT"
	],
	[
		"PR",
		"PRI",
		"630",
		"ISO 3166-2:PR"
	],
	[
		"QA",
		"QAT",
		"634",
		"ISO 3166-2:QA"
	],
	[
		"RE",
		"REU",
		"638",
		"ISO 3166-2:RE"
	],
	[
		"RO",
		"ROU",
		"642",
		"ISO 3166-2:RO"
	],
	[
		"RU",
		"RUS",
		"643",
		"ISO 3166-2:RU"
	],
	[
		"RW",
		"RWA",
		"646",
		"ISO 3166-2:RW"
	],
	[
		"SH",
		"SHN",
		"654",
		"ISO 3166-2:SH"
	],
	[
		"KN",
		"KNA",
		"659",
		"ISO 3166-2:KN"
	],
	[
		"LC",
		"LCA",
		"662",
		"ISO 3166-2:LC"
	],
	[
		"PM",
		"SPM",
		"666",
		"ISO 3166-2:PM"
	],
	[
		"VC",
		"VCT",
		"670",
		"ISO 3166-2:VC"
	],
	[
		"WS",
		"WSM",
		"882",
		"ISO 3166-2:WS"
	],
	[
		"SM",
		"SMR",
		"674",
		"ISO 3166-2:SM"
	],
	[
		"ST",
		"STP",
		"678",
		"ISO 3166-2:ST"
	],
	[
		"SA",
		"SAU",
		"682",
		"ISO 3166-2:SA"
	],
	[
		"SN",
		"SEN",
		"686",
		"ISO 3166-2:SN"
	],
	[
		"SC",
		"SYC",
		"690",
		"ISO 3166-2:SC"
	],
	[
		"SL",
		"SLE",
		"694",
		"ISO 3166-2:SL"
	],
	[
		"SG",
		"SGP",
		"702",
		"ISO 3166-2:SG"
	],
	[
		"SK",
		"SVK",
		"703",
		"ISO 3166-2:SK"
	],
	[
		"SI",
		"SVN",
		"705",
		"ISO 3166-2:SI"
	],
	[
		"SB",
		"SLB",
		"090",
		"ISO 3166-2:SB"
	],
	[
		"SO",
		"SOM",
		"706",
		"ISO 3166-2:SO"
	],
	[
		"ZA",
		"ZAF",
		"710",
		"ISO 3166-2:ZA"
	],
	[
		"GS",
		"SGS",
		"239",
		"ISO 3166-2:GS"
	],
	[
		"ES",
		"ESP",
		"724",
		"ISO 3166-2:ES"
	],
	[
		"LK",
		"LKA",
		"144",
		"ISO 3166-2:LK"
	],
	[
		"SD",
		"SDN",
		"729",
		"ISO 3166-2:SD"
	],
	[
		"SR",
		"SUR",
		"740",
		"ISO 3166-2:SR"
	],
	[
		"SJ",
		"SJM",
		"744",
		"ISO 3166-2:SJ"
	],
	[
		"SZ",
		"SWZ",
		"748",
		"ISO 3166-2:SZ"
	],
	[
		"SE",
		"SWE",
		"752",
		"ISO 3166-2:SE"
	],
	[
		"CH",
		"CHE",
		"756",
		"ISO 3166-2:CH"
	],
	[
		"SY",
		"SYR",
		"760",
		"ISO 3166-2:SY"
	],
	[
		"TW",
		"TWN",
		"158",
		"ISO 3166-2:TW"
	],
	[
		"TJ",
		"TJK",
		"762",
		"ISO 3166-2:TJ"
	],
	[
		"TZ",
		"TZA",
		"834",
		"ISO 3166-2:TZ"
	],
	[
		"TH",
		"THA",
		"764",
		"ISO 3166-2:TH"
	],
	[
		"TL",
		"TLS",
		"626",
		"ISO 3166-2:TL"
	],
	[
		"TG",
		"TGO",
		"768",
		"ISO 3166-2:TG"
	],
	[
		"TK",
		"TKL",
		"772",
		"ISO 3166-2:TK"
	],
	[
		"TO",
		"TON",
		"776",
		"ISO 3166-2:TO"
	],
	[
		"TT",
		"TTO",
		"780",
		"ISO 3166-2:TT"
	],
	[
		"TN",
		"TUN",
		"788",
		"ISO 3166-2:TN"
	],
	[
		"TR",
		"TUR",
		"792",
		"ISO 3166-2:TR"
	],
	[
		"TM",
		"TKM",
		"795",
		"ISO 3166-2:TM"
	],
	[
		"TC",
		"TCA",
		"796",
		"ISO 3166-2:TC"
	],
	[
		"TV",
		"TUV",
		"798",
		"ISO 3166-2:TV"
	],
	[
		"UG",
		"UGA",
		"800",
		"ISO 3166-2:UG"
	],
	[
		"UA",
		"UKR",
		"804",
		"ISO 3166-2:UA"
	],
	[
		"AE",
		"ARE",
		"784",
		"ISO 3166-2:AE"
	],
	[
		"GB",
		"GBR",
		"826",
		"ISO 3166-2:GB"
	],
	[
		"US",
		"USA",
		"840",
		"ISO 3166-2:US"
	],
	[
		"UM",
		"UMI",
		"581",
		"ISO 3166-2:UM"
	],
	[
		"UY",
		"URY",
		"858",
		"ISO 3166-2:UY"
	],
	[
		"UZ",
		"UZB",
		"860",
		"ISO 3166-2:UZ"
	],
	[
		"VU",
		"VUT",
		"548",
		"ISO 3166-2:VU"
	],
	[
		"VE",
		"VEN",
		"862",
		"ISO 3166-2:VE"
	],
	[
		"VN",
		"VNM",
		"704",
		"ISO 3166-2:VN"
	],
	[
		"VG",
		"VGB",
		"092",
		"ISO 3166-2:VG"
	],
	[
		"VI",
		"VIR",
		"850",
		"ISO 3166-2:VI"
	],
	[
		"WF",
		"WLF",
		"876",
		"ISO 3166-2:WF"
	],
	[
		"EH",
		"ESH",
		"732",
		"ISO 3166-2:EH"
	],
	[
		"YE",
		"YEM",
		"887",
		"ISO 3166-2:YE"
	],
	[
		"ZM",
		"ZMB",
		"894",
		"ISO 3166-2:ZM"
	],
	[
		"ZW",
		"ZWE",
		"716",
		"ISO 3166-2:ZW"
	],
	[
		"AX",
		"ALA",
		"248",
		"ISO 3166-2:AX"
	],
	[
		"BQ",
		"BES",
		"535",
		"ISO 3166-2:BQ"
	],
	[
		"CW",
		"CUW",
		"531",
		"ISO 3166-2:CW"
	],
	[
		"GG",
		"GGY",
		"831",
		"ISO 3166-2:GG"
	],
	[
		"IM",
		"IMN",
		"833",
		"ISO 3166-2:IM"
	],
	[
		"JE",
		"JEY",
		"832",
		"ISO 3166-2:JE"
	],
	[
		"ME",
		"MNE",
		"499",
		"ISO 3166-2:ME"
	],
	[
		"BL",
		"BLM",
		"652",
		"ISO 3166-2:BL"
	],
	[
		"MF",
		"MAF",
		"663",
		"ISO 3166-2:MF"
	],
	[
		"RS",
		"SRB",
		"688",
		"ISO 3166-2:RS"
	],
	[
		"SX",
		"SXM",
		"534",
		"ISO 3166-2:SX"
	],
	[
		"SS",
		"SSD",
		"728",
		"ISO 3166-2:SS"
	],
	[
		"XK",
		"XKX",
		"983",
		"ISO 3166-2:XK"
	]
];

const locale$4 = "en";
const countries$5 = {
	AF: "Afghanistan",
	AL: "Albania",
	DZ: "Algeria",
	AS: "American Samoa",
	AD: "Andorra",
	AO: "Angola",
	AI: "Anguilla",
	AQ: "Antarctica",
	AG: "Antigua and Barbuda",
	AR: "Argentina",
	AM: "Armenia",
	AW: "Aruba",
	AU: "Australia",
	AT: "Austria",
	AZ: "Azerbaijan",
	BS: "Bahamas",
	BH: "Bahrain",
	BD: "Bangladesh",
	BB: "Barbados",
	BY: "Belarus",
	BE: "Belgium",
	BZ: "Belize",
	BJ: "Benin",
	BM: "Bermuda",
	BT: "Bhutan",
	BO: "Bolivia",
	BA: "Bosnia and Herzegovina",
	BW: "Botswana",
	BV: "Bouvet Island",
	BR: "Brazil",
	IO: "British Indian Ocean Territory",
	BN: "Brunei Darussalam",
	BG: "Bulgaria",
	BF: "Burkina Faso",
	BI: "Burundi",
	KH: "Cambodia",
	CM: "Cameroon",
	CA: "Canada",
	CV: "Cape Verde",
	KY: "Cayman Islands",
	CF: "Central African Republic",
	TD: "Chad",
	CL: "Chile",
	CN: [
		"People's Republic of China",
		"China"
	],
	CX: "Christmas Island",
	CC: "Cocos (Keeling) Islands",
	CO: "Colombia",
	KM: "Comoros",
	CG: [
		"Republic of the Congo",
		"Congo"
	],
	CD: [
		"Democratic Republic of the Congo",
		"Congo"
	],
	CK: "Cook Islands",
	CR: "Costa Rica",
	CI: [
		"Cote D'Ivoire",
		"Ivory Coast"
	],
	HR: "Croatia",
	CU: "Cuba",
	CY: "Cyprus",
	CZ: [
		"Czech Republic",
		"Czechia"
	],
	DK: "Denmark",
	DJ: "Djibouti",
	DM: "Dominica",
	DO: "Dominican Republic",
	EC: "Ecuador",
	EG: "Egypt",
	SV: "El Salvador",
	GQ: "Equatorial Guinea",
	ER: "Eritrea",
	EE: "Estonia",
	ET: "Ethiopia",
	FK: "Falkland Islands (Malvinas)",
	FO: "Faroe Islands",
	FJ: "Fiji",
	FI: "Finland",
	FR: "France",
	GF: "French Guiana",
	PF: "French Polynesia",
	TF: "French Southern Territories",
	GA: "Gabon",
	GM: [
		"Republic of The Gambia",
		"The Gambia",
		"Gambia"
	],
	GE: "Georgia",
	DE: "Germany",
	GH: "Ghana",
	GI: "Gibraltar",
	GR: "Greece",
	GL: "Greenland",
	GD: "Grenada",
	GP: "Guadeloupe",
	GU: "Guam",
	GT: "Guatemala",
	GN: "Guinea",
	GW: "Guinea-Bissau",
	GY: "Guyana",
	HT: "Haiti",
	HM: "Heard Island and McDonald Islands",
	VA: "Holy See (Vatican City State)",
	HN: "Honduras",
	HK: "Hong Kong",
	HU: "Hungary",
	IS: "Iceland",
	IN: "India",
	ID: "Indonesia",
	IR: [
		"Islamic Republic of Iran",
		"Iran"
	],
	IQ: "Iraq",
	IE: "Ireland",
	IL: "Israel",
	IT: "Italy",
	JM: "Jamaica",
	JP: "Japan",
	JO: "Jordan",
	KZ: "Kazakhstan",
	KE: "Kenya",
	KI: "Kiribati",
	KP: "North Korea",
	KR: "South Korea",
	KW: "Kuwait",
	KG: "Kyrgyzstan",
	LA: "Lao People's Democratic Republic",
	LV: "Latvia",
	LB: "Lebanon",
	LS: "Lesotho",
	LR: "Liberia",
	LY: "Libya",
	LI: "Liechtenstein",
	LT: "Lithuania",
	LU: "Luxembourg",
	MO: "Macao",
	MG: "Madagascar",
	MW: "Malawi",
	MY: "Malaysia",
	MV: "Maldives",
	ML: "Mali",
	MT: "Malta",
	MH: "Marshall Islands",
	MQ: "Martinique",
	MR: "Mauritania",
	MU: "Mauritius",
	YT: "Mayotte",
	MX: "Mexico",
	FM: "Micronesia, Federated States of",
	MD: "Moldova, Republic of",
	MC: "Monaco",
	MN: "Mongolia",
	MS: "Montserrat",
	MA: "Morocco",
	MZ: "Mozambique",
	MM: "Myanmar",
	NA: "Namibia",
	NR: "Nauru",
	NP: "Nepal",
	NL: "Netherlands",
	NC: "New Caledonia",
	NZ: "New Zealand",
	NI: "Nicaragua",
	NE: "Niger",
	NG: "Nigeria",
	NU: "Niue",
	NF: "Norfolk Island",
	MK: [
		"The Republic of North Macedonia",
		"North Macedonia"
	],
	MP: "Northern Mariana Islands",
	NO: "Norway",
	OM: "Oman",
	PK: "Pakistan",
	PW: "Palau",
	PS: [
		"State of Palestine",
		"Palestine"
	],
	PA: "Panama",
	PG: "Papua New Guinea",
	PY: "Paraguay",
	PE: "Peru",
	PH: "Philippines",
	PN: "Pitcairn",
	PL: "Poland",
	PT: "Portugal",
	PR: "Puerto Rico",
	QA: "Qatar",
	RE: "Reunion",
	RO: "Romania",
	RU: [
		"Russian Federation",
		"Russia"
	],
	RW: "Rwanda",
	SH: "Saint Helena",
	KN: "Saint Kitts and Nevis",
	LC: "Saint Lucia",
	PM: "Saint Pierre and Miquelon",
	VC: "Saint Vincent and the Grenadines",
	WS: "Samoa",
	SM: "San Marino",
	ST: "Sao Tome and Principe",
	SA: "Saudi Arabia",
	SN: "Senegal",
	SC: "Seychelles",
	SL: "Sierra Leone",
	SG: "Singapore",
	SK: "Slovakia",
	SI: "Slovenia",
	SB: "Solomon Islands",
	SO: "Somalia",
	ZA: "South Africa",
	GS: "South Georgia and the South Sandwich Islands",
	ES: "Spain",
	LK: "Sri Lanka",
	SD: "Sudan",
	SR: "Suriname",
	SJ: "Svalbard and Jan Mayen",
	SZ: "Eswatini",
	SE: "Sweden",
	CH: "Switzerland",
	SY: "Syrian Arab Republic",
	TW: [
		"Taiwan, Province of China",
		"Taiwan"
	],
	TJ: "Tajikistan",
	TZ: [
		"United Republic of Tanzania",
		"Tanzania"
	],
	TH: "Thailand",
	TL: "Timor-Leste",
	TG: "Togo",
	TK: "Tokelau",
	TO: "Tonga",
	TT: "Trinidad and Tobago",
	TN: "Tunisia",
	TR: "Turkey",
	TM: "Turkmenistan",
	TC: "Turks and Caicos Islands",
	TV: "Tuvalu",
	UG: "Uganda",
	UA: "Ukraine",
	AE: "United Arab Emirates",
	GB: [
		"United Kingdom",
		"UK",
		"Great Britain"
	],
	US: [
		"United States of America",
		"United States",
		"USA"
	],
	UM: "United States Minor Outlying Islands",
	UY: "Uruguay",
	UZ: "Uzbekistan",
	VU: "Vanuatu",
	VE: "Venezuela",
	VN: "Vietnam",
	VG: "Virgin Islands, British",
	VI: "Virgin Islands, U.S.",
	WF: "Wallis and Futuna",
	EH: "Western Sahara",
	YE: "Yemen",
	ZM: "Zambia",
	ZW: "Zimbabwe",
	AX: "Åland Islands",
	BQ: "Bonaire, Sint Eustatius and Saba",
	CW: "Curaçao",
	GG: "Guernsey",
	IM: "Isle of Man",
	JE: "Jersey",
	ME: "Montenegro",
	BL: "Saint Barthélemy",
	MF: "Saint Martin (French part)",
	RS: "Serbia",
	SX: "Sint Maarten (Dutch part)",
	SS: "South Sudan",
	XK: "Kosovo"
};
const en = {
	locale: locale$4,
	countries: countries$5
};

const locale$3 = "es";
const countries$4 = {
	AF: "Afganistán",
	AL: "Albania",
	DZ: "Argelia",
	AS: "Samoa Americana",
	AD: "Andorra",
	AO: "Angola",
	AI: "Anguila",
	AQ: "Antártida",
	AG: "Antigua y Barbuda",
	AR: "Argentina",
	AM: "Armenia",
	AW: "Aruba",
	AU: "Australia",
	AT: "Austria",
	AZ: "Azerbaiyán",
	BS: "Bahamas",
	BH: "Bahrein",
	BD: "Bangladesh",
	BB: "Barbados",
	BY: "Bielorrusia",
	BE: "Bélgica",
	BZ: "Belice",
	BJ: "Benin",
	BM: "Bermudas",
	BT: "Bután",
	BO: "Bolivia",
	BA: "Bosnia y Herzegovina",
	BW: "Botswana",
	BV: "Isla Bouvet",
	BR: "Brasil",
	IO: "Territorio Británico del Océano Índico",
	BN: "Brunei Darussalam",
	BG: "Bulgaria",
	BF: "Burkina Faso",
	BI: "Burundi",
	KH: "Camboya",
	CM: "Camerún",
	CA: "Canadá",
	CV: "Cabo Verde",
	KY: "Islas Caimán",
	CF: "República Centroafricana",
	TD: "Chad",
	CL: "Chile",
	CN: "China",
	CX: "Isla de Navidad",
	CC: "Islas Cocos (Keeling)",
	CO: "Colombia",
	KM: "Comoras",
	CG: "Congo",
	CD: "Congo (República Democrática del)",
	CK: "Islas Cook",
	CR: "Costa Rica",
	CI: "Costa de Marfil",
	HR: "Croacia",
	CU: "Cuba",
	CY: "Chipre",
	CZ: "República Checa",
	DK: "Dinamarca",
	DJ: "Yibuti",
	DM: "Dominica",
	DO: "República Dominicana",
	EC: "Ecuador",
	EG: "Egipto",
	SV: "El Salvador",
	GQ: "Guinea Ecuatorial",
	ER: "Eritrea",
	EE: "Estonia",
	ET: "Etiopía",
	FK: "Islas Malvinas",
	FO: "Islas Feroe",
	FJ: "Fiji",
	FI: "Finlandia",
	FR: "Francia",
	GF: "Guayana Francesa",
	PF: "Polinesia Francesa",
	TF: "Tierras Australes Francesas",
	GA: "Gabón",
	GM: "Gambia",
	GE: "Georgia",
	DE: "Alemania",
	GH: "Ghana",
	GI: "Gibraltar",
	GR: "Grecia",
	GL: "Groenlandia",
	GD: "Granada",
	GP: "Guadalupe",
	GU: "Guam",
	GT: "Guatemala",
	GN: "Guinea",
	GW: "Guinea Bissau",
	GY: "Guyana",
	HT: "Haití",
	HM: "Heard e Islas McDonald",
	VA: "Santa Sede",
	HN: "Honduras",
	HK: "Hong Kong",
	HU: "Hungría",
	IS: "Islandia",
	IN: "India",
	ID: "Indonesia",
	IR: [
		"Irán",
		"República Islámica de Irán"
	],
	IQ: "Iraq",
	IE: "Irlanda",
	IL: "Israel",
	IT: "Italia",
	JM: "Jamaica",
	JP: "Japón",
	JO: "Jordania",
	KZ: "Kazajistán",
	KE: "Kenia",
	KI: "Kiribati",
	KP: "República Popular Democrática de Corea",
	KR: "República de Corea",
	KW: "Kuwait",
	KG: "Kirguistán",
	LA: "República Democrática Popular de Lao",
	LV: "Letonia",
	LB: "Líbano",
	LS: "Lesoto",
	LR: "Liberia",
	LY: "Libia",
	LI: "Liechtenstein",
	LT: "Lituania",
	LU: "Luxemburgo",
	MO: "Macao",
	MK: "Macedonia del Norte",
	MG: "Madagascar",
	MW: "Malaui",
	MY: "Malasia",
	MV: "Maldivas",
	ML: "Malí",
	MT: "Malta",
	MH: "Islas Marshall",
	MQ: "Martinica",
	MR: "Mauritania",
	MU: "Mauricio",
	YT: "Mayotte",
	MX: "México",
	FM: "Micronesia",
	MD: "Moldavia",
	MC: "Mónaco",
	MN: "Mongolia",
	MS: "Montserrat",
	MA: "Marruecos",
	MZ: "Mozambique",
	MM: "Myanmar",
	NA: "Namibia",
	NR: "Nauru",
	NP: "Nepal",
	NL: "Países Bajos",
	NC: "Nueva Caledonia",
	NZ: "Nueva Zelanda",
	NI: "Nicaragua",
	NE: "Níger",
	NG: "Nigeria",
	NU: "Niue",
	NF: "Isla Norfolk",
	MP: "Islas Marianas del Norte",
	NO: "Noruega",
	OM: "Omán",
	PK: "Pakistán",
	PW: "Palau",
	PS: "Palestina",
	PA: "Panamá",
	PG: "Papua Nueva Guinea",
	PY: "Paraguay",
	PE: "Perú",
	PH: "Filipinas",
	PN: "Pitcairn",
	PL: "Polonia",
	PT: "Portugal",
	PR: "Puerto Rico",
	QA: "Catar",
	RE: "Reunión",
	RO: "Rumanía",
	RU: "Rusia",
	RW: "Ruanda",
	SH: "Santa Helena, Ascensión y Tristán de Acuña",
	KN: "Saint Kitts y Nevis",
	LC: "Santa Lucía",
	PM: "San Pedro y Miquelón",
	VC: "San Vicente y las Granadinas",
	WS: "Samoa",
	SM: "San Marino",
	ST: "Santo Tomé y Príncipe",
	SA: "Arabia Saudita",
	SN: "Senegal",
	SC: "Seychelles",
	SL: "Sierra Leona",
	SG: "Singapur",
	SK: "Eslovaquia",
	SI: "Eslovenia",
	SB: "Islas Salomón",
	SO: "Somalia",
	ZA: "Sudáfrica",
	GS: "Georgia del Sur y las Islas Sandwich del Sur",
	ES: "España",
	LK: "Sri Lanka",
	SD: "Sudán",
	SR: "Suriname",
	SJ: "Svalbard y Jan Mayen",
	SZ: "Suazilandia",
	SE: "Suecia",
	CH: "Suiza",
	SY: "República Árabe Siria",
	TW: "Taiwán",
	TJ: "Tayikistán",
	TZ: "Tanzania",
	TH: "Tailandia",
	TL: "Timor-Leste",
	TG: "Togo",
	TK: "Tokelau",
	TO: "Tonga",
	TT: "Trinidad y Tobago",
	TN: "Túnez",
	TR: "Turquía",
	TM: "Turkmenistán",
	TC: "Islas Turcas y Caicos",
	TV: "Tuvalu",
	UG: "Uganda",
	UA: "Ucrania",
	AE: "Emiratos Árabes Unidos",
	GB: "Reino Unido",
	US: "Estados Unidos",
	UM: "Islas Ultramarinas Menores de los Estados Unidos",
	UY: "Uruguay",
	UZ: "Uzbekistán",
	VU: "Vanuatu",
	VE: "Venezuela",
	VN: "Vietnam",
	VG: "Islas Vírgenes británicas",
	VI: "Islas Vírgenes de los Estados Unidos",
	WF: "Wallis y Futuna",
	EH: "Sahara Occidental",
	YE: "Yemen",
	ZM: "Zambia",
	ZW: "Zimbabue",
	AX: "Islas Åland",
	BQ: "Bonaire, San Eustaquio y Saba",
	CW: "Curaçao",
	GG: "Guernsey",
	IM: "Isla de Man",
	JE: "Jersey",
	ME: "Montenegro",
	BL: "Saint Barthélemy",
	MF: "Saint Martin (francesa)",
	RS: "Serbia",
	SX: "Sint Maarten (neerlandesa)",
	SS: "Sudán del Sur",
	XK: "Kosovo"
};
const es = {
	locale: locale$3,
	countries: countries$4
};

const locale$2 = "fr";
const countries$3 = {
	AF: "Afghanistan",
	AL: "Albanie",
	DZ: "Algérie",
	AS: "Samoa américaines",
	AD: "Andorre",
	AO: "Angola",
	AI: "Anguilla",
	AQ: "Antarctique",
	AG: "Antigua-et-Barbuda",
	AR: "Argentine",
	AM: "Arménie",
	AW: "Aruba",
	AU: "Australie",
	AT: "Autriche",
	AZ: "Azerbaïdjan",
	BS: "Bahamas",
	BH: "Bahreïn",
	BD: "Bangladesh",
	BB: "Barbade",
	BY: "Biélorussie",
	BE: "Belgique",
	BZ: "Belize",
	BJ: "Bénin",
	BM: "Bermudes",
	BT: "Bhoutan",
	BO: "Bolivie",
	BA: "Bosnie-Herzégovine",
	BW: "Botswana",
	BV: "Île Bouvet",
	BR: "Brésil",
	IO: "Océan Indien Britannique",
	BN: "Brunei Darussalam",
	BG: "Bulgarie",
	BF: "Burkina Faso",
	BI: "Burundi",
	KH: "Cambodge",
	CM: "Cameroun",
	CA: "Canada",
	CV: "Cap-Vert",
	KY: "Îles Caïmans",
	CF: "République Centrafricaine",
	TD: "Tchad",
	CL: "Chili",
	CN: "Chine",
	CX: "Île Christmas",
	CC: "Îles Cocos",
	CO: "Colombie",
	KM: "Comores",
	CG: "République du Congo",
	CD: "République démocratique du Congo",
	CK: "Îles Cook",
	CR: "Costa Rica",
	CI: "Côte-d'Ivoire",
	HR: "Croatie",
	CU: "Cuba",
	CY: "Chypre",
	CZ: "République Tchèque",
	DK: "Danemark",
	DJ: "Djibouti",
	DM: "Dominique",
	DO: "République Dominicaine",
	EC: "Équateur",
	EG: "Égypte",
	SV: "El Salvador",
	GQ: "Guinée équatoriale",
	ER: "Érythrée",
	EE: "Estonie",
	ET: "Éthiopie",
	FK: "Îles Malouines",
	FO: "Îles Féroé",
	FJ: "Fidji",
	FI: "Finlande",
	FR: "France",
	GF: "Guyane française",
	PF: "Polynésie française",
	TF: "Terres australes françaises",
	GA: "Gabon",
	GM: "Gambie",
	GE: "Géorgie",
	DE: "Allemagne",
	GH: "Ghana",
	GI: "Gibraltar",
	GR: "Grèce",
	GL: "Groenland",
	GD: "Grenade",
	GP: "Guadeloupe",
	GU: "Guam",
	GT: "Guatemala",
	GN: "Guinée",
	GW: "Guinée-Bissau",
	GY: "Guyana",
	HT: "Haïti",
	HM: "Îles Heard-et-MacDonald",
	VA: "Saint-Siège (Vatican)",
	HN: "Honduras",
	HK: "Hong Kong",
	HU: "Hongrie",
	IS: "Islande",
	IN: "Inde",
	ID: "Indonésie",
	IR: "Iran",
	IQ: "Irak",
	IE: "Irlande",
	IL: "Israël",
	IT: "Italie",
	JM: "Jamaïque",
	JP: "Japon",
	JO: "Jordanie",
	KZ: "Kazakhstan",
	KE: "Kenya",
	KI: "Kiribati",
	KP: "Corée du Nord",
	KR: "Corée du Sud",
	KW: "Koweït",
	KG: "Kirghizistan",
	LA: "Laos",
	LV: "Lettonie",
	LB: "Liban",
	LS: "Lesotho",
	LR: "Libéria",
	LY: "Libye",
	LI: "Liechtenstein",
	LT: "Lituanie",
	LU: "Luxembourg",
	MO: "Macao",
	MK: "Macédoine du Nord",
	MG: "Madagascar",
	MW: "Malawi",
	MY: "Malaisie",
	MV: "Maldives",
	ML: "Mali",
	MT: "Malte",
	MH: "Îles Marshall",
	MQ: "Martinique",
	MR: "Mauritanie",
	MU: "Maurice",
	YT: "Mayotte",
	MX: "Mexique",
	FM: "Micronésie",
	MD: "Moldavie",
	MC: "Monaco",
	MN: "Mongolie",
	MS: "Montserrat",
	MA: "Maroc",
	MZ: "Mozambique",
	MM: "Myanmar",
	NA: "Namibie",
	NR: "Nauru",
	NP: "Népal",
	NL: "Pays-Bas",
	NC: "Nouvelle-Calédonie",
	NZ: "Nouvelle-Zélande",
	NI: "Nicaragua",
	NE: "Niger",
	NG: "Nigéria",
	NU: "Niué",
	NF: "Île Norfolk",
	MP: "Îles Mariannes du Nord",
	NO: "Norvège",
	OM: "Oman",
	PK: "Pakistan",
	PW: "Palaos",
	PS: "Palestine",
	PA: "Panama",
	PG: "Papouasie-Nouvelle-Guinée",
	PY: "Paraguay",
	PE: "Pérou",
	PH: "Philippines",
	PN: "Îles Pitcairn",
	PL: "Pologne",
	PT: "Portugal",
	PR: "Porto Rico",
	QA: "Qatar",
	RE: "Réunion",
	RO: "Roumanie",
	RU: "Russie",
	RW: "Rwanda",
	SH: "Sainte-Hélène",
	KN: "Saint-Christophe-et-Niévès",
	LC: "Sainte-Lucie",
	PM: "Saint-Pierre-et-Miquelon",
	VC: "Saint-Vincent-et-les-Grenadines",
	WS: "Samoa",
	SM: "Saint-Marin",
	ST: "São Tomé-et-Principe",
	SA: "Arabie Saoudite",
	SN: "Sénégal",
	SC: "Seychelles",
	SL: "Sierra Leone",
	SG: "Singapour",
	SK: "Slovaquie",
	SI: "Slovénie",
	SB: "Îles Salomon",
	SO: "Somalie",
	ZA: "Afrique du Sud",
	GS: "Géorgie du Sud-et-les Îles Sandwich du Sud",
	ES: "Espagne",
	LK: "Sri Lanka",
	SD: "Soudan",
	SR: "Suriname",
	SJ: "Svalbard et Île Jan Mayen",
	SZ: "Royaume d'Eswatini",
	SE: "Suède",
	CH: "Suisse",
	SY: "Syrie",
	TW: "Taïwan",
	TJ: "Tadjikistan",
	TZ: "République unie de Tanzanie",
	TH: "Thaïlande",
	TL: "Timor-Leste",
	TG: "Togo",
	TK: "Tokelau",
	TO: "Tonga",
	TT: "Trinité-et-Tobago",
	TN: "Tunisie",
	TR: "Turquie",
	TM: "Turkménistan",
	TC: "Îles Turques-et-Caïques",
	TV: "Tuvalu",
	UG: "Ouganda",
	UA: "Ukraine",
	AE: "Émirats Arabes Unis",
	GB: "Royaume-Uni",
	US: "États-Unis d'Amérique",
	UM: "Îles mineures éloignées des États-Unis",
	UY: "Uruguay",
	UZ: "Ouzbékistan",
	VU: "Vanuatu",
	VE: "Venezuela",
	VN: "Vietnam",
	VG: "Îles vierges britanniques",
	VI: "Îles vierges américaines",
	WF: "Wallis-et-Futuna",
	EH: "Sahara occidental",
	YE: "Yémen",
	ZM: "Zambie",
	ZW: "Zimbabwe",
	AX: "Åland",
	BQ: "Bonaire, Saint-Eustache et Saba",
	CW: "Curaçao",
	GG: "Guernesey",
	IM: "Île de Man",
	JE: "Jersey",
	ME: "Monténégro",
	BL: "Saint-Barthélemy",
	MF: "Saint-Martin (partie française)",
	RS: "Serbie",
	SX: "Saint-Martin (partie néerlandaise)",
	SS: "Soudan du Sud",
	XK: "Kosovo"
};
const fr = {
	locale: locale$2,
	countries: countries$3
};

const locale$1 = "de";
const countries$2 = {
	AF: "Afghanistan",
	EG: "Ägypten",
	AX: "Åland",
	AL: "Albanien",
	DZ: "Algerien",
	AS: "Amerikanisch-Samoa",
	VI: "Amerikanische Jungferninseln",
	AD: "Andorra",
	AO: "Angola",
	AI: "Anguilla",
	AQ: "Antarktis",
	AG: "Antigua und Barbuda",
	GQ: "Äquatorialguinea",
	AR: "Argentinien",
	AM: "Armenien",
	AW: "Aruba",
	AZ: "Aserbaidschan",
	ET: "Äthiopien",
	AU: "Australien",
	BS: "Bahamas",
	BH: "Bahrain",
	BD: "Bangladesch",
	BB: "Barbados",
	BY: "Belarus",
	BE: "Belgien",
	BZ: "Belize",
	BJ: "Benin",
	BM: "Bermuda",
	BT: "Bhutan",
	BO: "Bolivien",
	BQ: "Bonaire",
	BA: "Bosnien und Herzegowina",
	BW: "Botswana",
	BV: "Bouvetinsel",
	BR: "Brasilien",
	VG: "Britische Jungferninseln",
	IO: "Britisches Territorium im Indischen Ozean",
	BN: "Brunei Darussalam",
	BG: "Bulgarien",
	BF: "Burkina Faso",
	BI: "Burundi",
	CL: "Chile",
	CN: "China",
	CK: "Cookinseln",
	CR: "Costa Rica",
	CI: "Elfenbeinküste",
	CW: "Curaçao",
	DK: "Dänemark",
	DE: "Deutschland",
	DM: "Dominica",
	DO: "Dominikanische Republik",
	DJ: "Dschibuti",
	EC: "Ecuador",
	SV: "El Salvador",
	ER: "Eritrea",
	EE: "Estland",
	FK: "Falklandinseln",
	FO: "Färöer",
	FJ: "Fidschi",
	FI: "Finnland",
	FR: "Frankreich",
	GF: "Französisch-Guayana",
	PF: "Französisch-Polynesien",
	TF: "Französische Süd- und Antarktisgebiete",
	GA: "Gabun",
	GM: "Gambia",
	GE: "Georgien",
	GH: "Ghana",
	GI: "Gibraltar",
	GD: "Grenada",
	GR: "Griechenland",
	GL: "Grönland",
	GP: "Guadeloupe",
	GU: "Guam",
	GT: "Guatemala",
	GG: "Guernsey",
	GN: "Guinea",
	GW: "Guinea-Bissau",
	GY: "Guyana",
	HT: "Haiti",
	HM: "Heard und McDonaldinseln",
	HN: "Honduras",
	HK: "Hongkong",
	IN: "Indien",
	ID: "Indonesien",
	IM: "Insel Man",
	IQ: "Irak",
	IR: "Iran",
	IE: "Irland",
	IS: "Island",
	IL: "Israel",
	IT: "Italien",
	JM: "Jamaika",
	JP: "Japan",
	YE: "Jemen",
	JE: "Jersey",
	JO: "Jordanien",
	KY: "Kaimaninseln",
	KH: "Kambodscha",
	CM: "Kamerun",
	CA: "Kanada",
	CV: "Kap Verde",
	KZ: "Kasachstan",
	QA: "Katar",
	KE: "Kenia",
	KG: "Kirgisistan",
	KI: "Kiribati",
	CC: "Kokosinseln",
	CO: "Kolumbien",
	KM: "Komoren",
	CD: "Kongo",
	KP: "Nordkorea",
	KR: "Südkorea",
	HR: "Kroatien",
	CU: "Kuba",
	KW: "Kuwait",
	LA: "Laos",
	LS: "Lesotho",
	LV: "Lettland",
	LB: "Libanon",
	LR: "Liberia",
	LY: "Libyen",
	LI: "Liechtenstein",
	LT: "Litauen",
	LU: "Luxemburg",
	MO: "Macao",
	MG: "Madagaskar",
	MW: "Malawi",
	MY: "Malaysia",
	MV: "Malediven",
	ML: "Mali",
	MT: "Malta",
	MA: "Marokko",
	MH: "Marshallinseln",
	MQ: "Martinique",
	MR: "Mauretanien",
	MU: "Mauritius",
	YT: "Mayotte",
	MX: "Mexiko",
	FM: "Mikronesien",
	MD: "Moldawien",
	MC: "Monaco",
	MN: "Mongolei",
	ME: "Montenegro",
	MS: "Montserrat",
	MZ: "Mosambik",
	MM: "Myanmar",
	NA: "Namibia",
	NR: "Nauru",
	NP: "Nepal",
	NC: "Neukaledonien",
	NZ: "Neuseeland",
	NI: "Nicaragua",
	NL: "Niederlande",
	NE: "Niger",
	NG: "Nigeria",
	NU: "Niue",
	MK: "Nordmazedonien",
	MP: "Nördliche Marianen",
	NF: "Norfolkinsel",
	NO: "Norwegen",
	OM: "Oman",
	AT: "Österreich",
	TL: "Osttimor",
	PK: "Pakistan",
	PS: "Staat Palästina",
	PW: "Palau",
	PA: "Panama",
	PG: "Papua-Neuguinea",
	PY: "Paraguay",
	PE: "Peru",
	PH: "Philippinen",
	PN: "Pitcairninseln",
	PL: "Polen",
	PT: "Portugal",
	PR: "Puerto Rico",
	TW: "Taiwan",
	CG: "Republik Kongo",
	RE: "Réunion",
	RW: "Ruanda",
	RO: "Rumänien",
	RU: "Russische Föderation",
	BL: "Saint-Barthélemy",
	MF: "Saint-Martin",
	SB: "Salomonen",
	ZM: "Sambia",
	WS: "Samoa",
	SM: "San Marino",
	ST: "São Tomé und Príncipe",
	SA: "Saudi-Arabien",
	SE: "Schweden",
	CH: "Schweiz",
	SN: "Senegal",
	RS: "Serbien",
	SC: "Seychellen",
	SL: "Sierra Leone",
	ZW: "Simbabwe",
	SG: "Singapur",
	SX: "Sint Maarten",
	SK: "Slowakei",
	SI: "Slowenien",
	SO: "Somalia",
	ES: "Spanien",
	LK: "Sri Lanka",
	SH: "St. Helena",
	KN: "St. Kitts und Nevis",
	LC: "St. Lucia",
	PM: "Saint-Pierre und Miquelon",
	VC: "St. Vincent und die Grenadinen",
	ZA: "Südafrika",
	SD: "Sudan",
	GS: "Südgeorgien und die Südlichen Sandwichinseln",
	SS: "Südsudan",
	SR: "Suriname",
	SJ: "Svalbard und Jan Mayen",
	SZ: "Eswatini",
	SY: "Syrien, Arabische Republik",
	TJ: "Tadschikistan",
	TZ: "Tansania, Vereinigte Republik",
	TH: "Thailand",
	TG: "Togo",
	TK: "Tokelau",
	TO: "Tonga",
	TT: "Trinidad und Tobago",
	TD: "Tschad",
	CZ: "Tschechische Republik",
	TN: "Tunesien",
	TR: "Türkei",
	TM: "Turkmenistan",
	TC: "Turks- und Caicosinseln",
	TV: "Tuvalu",
	UG: "Uganda",
	UA: "Ukraine",
	HU: "Ungarn",
	UM: "United States Minor Outlying Islands",
	UY: "Uruguay",
	UZ: "Usbekistan",
	VU: "Vanuatu",
	VA: "Vatikanstadt",
	VE: "Venezuela",
	AE: "Vereinigte Arabische Emirate",
	US: [
		"Vereinigte Staaten von Amerika",
		"Vereinigte Staaten",
		"USA"
	],
	GB: [
		"Vereinigtes Königreich",
		"Großbritannien"
	],
	VN: "Vietnam",
	WF: "Wallis und Futuna",
	CX: "Weihnachtsinsel",
	EH: "Westsahara",
	CF: "Zentralafrikanische Republik",
	CY: "Zypern",
	XK: "Kosovo"
};
const de = {
	locale: locale$1,
	countries: countries$2
};

const locale = "it";
const countries$1 = {
	AD: "Andorra",
	AE: "Emirati Arabi Uniti",
	AF: "Afghanistan",
	AG: "Antigua e Barbuda",
	AI: "Anguilla",
	AL: "Albania",
	AM: "Armenia",
	AO: "Angola",
	AQ: "Antartide",
	AR: "Argentina",
	AS: "Samoa Americane",
	AT: "Austria",
	AU: "Australia",
	AW: "Aruba",
	AX: "Isole Åland",
	AZ: "Azerbaigian",
	BA: "Bosnia ed Erzegovina",
	BB: "Barbados",
	BD: "Bangladesh",
	BE: "Belgio",
	BF: "Burkina Faso",
	BG: "Bulgaria",
	BH: "Bahrain",
	BI: "Burundi",
	BJ: "Benin",
	BL: "Saint-Barthélemy",
	BM: "Bermuda",
	BN: "Brunei",
	BO: "Bolivia",
	BQ: "Isole BES",
	BR: "Brasile",
	BS: "Bahamas",
	BT: "Bhutan",
	BV: "Isola Bouvet",
	BW: "Botswana",
	BY: "Bielorussia",
	BZ: "Belize",
	CA: "Canada",
	CC: "Isole Cocos e Keeling",
	CD: "Repubblica Democratica del Congo",
	CF: "Repubblica Centrafricana",
	CG: "Repubblica del Congo",
	CH: "Svizzera",
	CI: "Costa d'Avorio",
	CK: "Isole Cook",
	CL: "Cile",
	CM: "Camerun",
	CN: "Cina",
	CO: "Colombia",
	CR: "Costa Rica",
	CU: "Cuba",
	CV: "Capo Verde",
	CW: "Curaçao",
	CX: "Isola del Natale",
	CY: "Cipro",
	CZ: "Repubblica Ceca",
	DE: "Germania",
	DJ: "Gibuti",
	DK: "Danimarca",
	DM: "Dominica",
	DO: "Repubblica Dominicana",
	DZ: "Algeria",
	EC: "Ecuador",
	EE: "Estonia",
	EG: "Egitto",
	EH: "Sahara Occidentale",
	ER: "Eritrea",
	ES: "Spagna",
	ET: "Etiopia",
	FI: "Finlandia",
	FJ: "Figi",
	FK: "Isole Falkland",
	FM: "Stati Federati di Micronesia",
	FO: "Isole Fær Øer",
	FR: "Francia",
	GA: "Gabon",
	GB: "Regno Unito",
	GD: "Grenada",
	GE: "Georgia",
	GF: "Guyana Francese",
	GG: "Guernsey",
	GH: "Ghana",
	GI: "Gibilterra",
	GL: "Groenlandia",
	GM: "Gambia",
	GN: "Guinea",
	GP: "Guadalupa",
	GQ: "Guinea Equatoriale",
	GR: "Grecia",
	GS: "Georgia del Sud e isole Sandwich meridionali",
	GT: "Guatemala",
	GU: "Guam",
	GW: "Guinea-Bissau",
	GY: "Guyana",
	HK: "Hong Kong",
	HM: "Isole Heard e McDonald",
	HN: "Honduras",
	HR: "Croazia",
	HT: "Haiti",
	HU: "Ungheria",
	ID: "Indonesia",
	IE: "Irlanda",
	IL: "Israele",
	IM: "Isola di Man",
	IN: "India",
	IO: "Territori Britannici dell'Oceano Indiano",
	IQ: "Iraq",
	IR: "Iran",
	IS: "Islanda",
	IT: "Italia",
	JE: "Jersey",
	JM: "Giamaica",
	JO: "Giordania",
	JP: "Giappone",
	KE: "Kenya",
	KG: "Kirghizistan",
	KH: "Cambogia",
	KI: "Kiribati",
	KM: "Comore",
	KN: "Saint Kitts e Nevis",
	KP: "Corea del Nord",
	KR: "Corea del Sud",
	KW: "Kuwait",
	KY: "Isole Cayman",
	KZ: "Kazakistan",
	LA: "Laos",
	LB: "Libano",
	LC: "Santa Lucia",
	LI: "Liechtenstein",
	LK: "Sri Lanka",
	LR: "Liberia",
	LS: "Lesotho",
	LT: "Lituania",
	LU: "Lussemburgo",
	LV: "Lettonia",
	LY: "Libia",
	MA: "Marocco",
	MC: "Monaco",
	MD: "Moldavia",
	ME: "Montenegro",
	MF: "Saint-Martin",
	MG: "Madagascar",
	MH: "Isole Marshall",
	MK: "Macedonia del Nord",
	ML: "Mali",
	MM: "Birmania  Myanmar",
	MN: "Mongolia",
	MO: "Macao",
	MP: "Isole Marianne Settentrionali",
	MQ: "Martinica",
	MR: "Mauritania",
	MS: "Montserrat",
	MT: "Malta",
	MU: "Mauritius",
	MV: "Maldive",
	MW: "Malawi",
	MX: "Messico",
	MY: "Malesia",
	MZ: "Mozambico",
	NA: "Namibia",
	NC: "Nuova Caledonia",
	NE: "Niger",
	NF: "Isola Norfolk",
	NG: "Nigeria",
	NI: "Nicaragua",
	NL: "Paesi Bassi",
	NO: "Norvegia",
	NP: "Nepal",
	NR: "Nauru",
	NU: "Niue",
	NZ: "Nuova Zelanda",
	OM: "Oman",
	PA: "Panamá",
	PE: "Perù",
	PF: "Polinesia Francese",
	PG: "Papua Nuova Guinea",
	PH: "Filippine",
	PK: "Pakistan",
	PL: "Polonia",
	PM: "Saint Pierre e Miquelon",
	PN: "Isole Pitcairn",
	PR: "Porto Rico",
	PS: "Stato di Palestina",
	PT: "Portogallo",
	PW: "Palau",
	PY: "Paraguay",
	QA: "Qatar",
	RE: "Réunion",
	RO: "Romania",
	RS: "Serbia",
	RU: "Russia",
	RW: "Ruanda",
	SA: "Arabia Saudita",
	SB: "Isole Salomone",
	SC: "Seychelles",
	SD: "Sudan",
	SE: "Svezia",
	SG: "Singapore",
	SH: "Sant'Elena, Isola di Ascensione e Tristan da Cunha",
	SI: "Slovenia",
	SJ: "Svalbard e Jan Mayen",
	SK: "Slovacchia",
	SL: "Sierra Leone",
	SM: "San Marino",
	SN: "Senegal",
	SO: "Somalia",
	SR: "Suriname",
	SS: "Sudan del Sud",
	ST: "São Tomé e Príncipe",
	SV: "El Salvador",
	SX: "Sint Maarten",
	SY: "Siria",
	SZ: "Eswatini",
	TC: "Isole Turks e Caicos",
	TD: "Ciad",
	TF: "Territori Francesi del Sud",
	TG: "Togo",
	TH: "Thailandia",
	TJ: "Tagikistan",
	TK: "Tokelau",
	TL: "Timor Est",
	TM: "Turkmenistan",
	TN: "Tunisia",
	TO: "Tonga",
	TR: "Turchia",
	TT: "Trinidad e Tobago",
	TV: "Tuvalu",
	TW: [
		"Repubblica di Cina",
		"Taiwan"
	],
	TZ: "Tanzania",
	UA: "Ucraina",
	UG: "Uganda",
	UM: "Isole minori esterne degli Stati Uniti",
	US: "Stati Uniti d'America",
	UY: "Uruguay",
	UZ: "Uzbekistan",
	VA: "Città del Vaticano",
	VC: "Saint Vincent e Grenadine",
	VE: "Venezuela",
	VG: "Isole Vergini Britanniche",
	VI: "Isole Vergini Americane",
	VN: "Vietnam",
	VU: "Vanuatu",
	WF: "Wallis e Futuna",
	WS: "Samoa",
	YE: "Yemen",
	YT: "Mayotte",
	ZA: "Sudafrica",
	ZM: "Zambia",
	ZW: "Zimbabwe",
	XK: "Kosovo"
};
const it = {
	locale: locale,
	countries: countries$1
};

var _package = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});const E=Object.freeze({AD:"EU",AE:"AS",AF:"AS",AG:"NA",AI:"NA",AL:"EU",AM:"AS",AO:"AF",AQ:"AN",AR:"SA",AS:"OC",AT:"EU",AU:"OC",AW:"NA",AX:"EU",AZ:"AS",BA:"EU",BB:"NA",BD:"AS",BE:"EU",BF:"AF",BG:"EU",BH:"AS",BI:"AF",BJ:"AF",BL:"NA",BM:"NA",BN:"AS",BO:"SA",BQ:"NA",BR:"SA",BS:"NA",BT:"AS",BV:"AN",BW:"AF",BY:"EU",BZ:"NA",CA:"NA",CC:"AS",CD:"AF",CF:"AF",CG:"AF",CH:"EU",CI:"AF",CK:"OC",CL:"SA",CM:"AF",CN:"AS",CO:"SA",CR:"NA",CU:"NA",CV:"AF",CW:"NA",CX:"AS",CY:"EU",CZ:"EU",DE:"EU",DJ:"AF",DK:"EU",DM:"NA",DO:"NA",DZ:"AF",EC:"SA",EE:"EU",EG:"AF",EH:"AF",ER:"AF",ES:"EU",ET:"AF",FI:"EU",FJ:"OC",FK:"SA",FM:"OC",FO:"EU",FR:"EU",GA:"AF",GB:"EU",GD:"NA",GE:"AS",GF:"SA",GG:"EU",GH:"AF",GI:"EU",GL:"NA",GM:"AF",GN:"AF",GP:"NA",GQ:"AF",GR:"EU",GS:"AN",GT:"NA",GU:"OC",GW:"AF",GY:"SA",HK:"AS",HM:"AN",HN:"NA",HR:"EU",HT:"NA",HU:"EU",ID:"AS",IE:"EU",IL:"AS",IM:"EU",IN:"AS",IO:"AS",IQ:"AS",IR:"AS",IS:"EU",IT:"EU",JE:"EU",JM:"NA",JO:"AS",JP:"AS",KE:"AF",KG:"AS",KH:"AS",KI:"OC",KM:"AF",KN:"NA",KP:"AS",KR:"AS",KW:"AS",KY:"NA",KZ:"AS",LA:"AS",LB:"AS",LC:"NA",LI:"EU",LK:"AS",LR:"AF",LS:"AF",LT:"EU",LU:"EU",LV:"EU",LY:"AF",MA:"AF",MC:"EU",MD:"EU",ME:"EU",MF:"NA",MG:"AF",MH:"OC",MK:"EU",ML:"AF",MM:"AS",MN:"AS",MO:"AS",MP:"OC",MQ:"NA",MR:"AF",MS:"NA",MT:"EU",MU:"AF",MV:"AS",MW:"AF",MX:"NA",MY:"AS",MZ:"AF",NA:"AF",NC:"OC",NE:"AF",NF:"OC",NG:"AF",NI:"NA",NL:"EU",NO:"EU",NP:"AS",NR:"OC",NU:"OC",NZ:"OC",OM:"AS",PA:"NA",PE:"SA",PF:"OC",PG:"OC",PH:"AS",PK:"AS",PL:"EU",PM:"NA",PN:"OC",PR:"NA",PS:"AS",PT:"EU",PW:"OC",PY:"SA",QA:"AS",RE:"AF",RO:"EU",RS:"EU",RU:"EU",RW:"AF",SA:"AS",SB:"OC",SC:"AF",SD:"AF",SE:"EU",SG:"AS",SH:"AF",SI:"EU",SJ:"EU",SK:"EU",SL:"AF",SM:"EU",SN:"AF",SO:"AF",SR:"SA",SS:"AF",ST:"AF",SV:"NA",SX:"NA",SY:"AS",SZ:"AF",TC:"NA",TD:"AF",TF:"AN",TG:"AF",TH:"AS",TJ:"AS",TK:"OC",TL:"OC",TM:"AS",TN:"AF",TO:"OC",TR:"AS",TT:"NA",TV:"OC",TW:"AS",TZ:"AF",UA:"EU",UG:"AF",UM:"OC",US:"NA",UY:"SA",UZ:"AS",VA:"EU",VC:"NA",VE:"SA",VG:"NA",VI:"NA",VN:"AS",VU:"OC",WF:"OC",WS:"OC",XK:"EU",YE:"AS",YT:"AF",ZA:"AF",ZM:"AF",ZW:"AF"}),N=Object.freeze({EU:"Europe",AS:"Asia",NA:"North America",SA:"South America",OC:"Oceania",AF:"Africa"});function F(A){const S=E[A.toUpperCase()];if(!S)throw new Error(`"${A}" is an invalid ISO country code`);return S}function C(A){const S=E[A.toUpperCase()];if(!S)throw new Error(`"${A}" is an invalid ISO country code`);return N[S]}exports.ContinentCodes=E,exports.ContinentNames=N,exports.getContinentCode=F,exports.getContinentName=C;
});

const langs = tuple('en', 'es', 'fr', 'de', 'it');
const returnTypes = tuple('alpha2', 'alpha3', 'numeric', 'numericString');
// some countries come with multiple translations, take the first "official" one
const firstOrString = (stringOrArray) => {
  if (Array.isArray(stringOrArray))
    return stringOrArray[0];
  return stringOrArray;
};
const continentCodes = Object.keys(_package.ContinentNames);
const countries = codes.filter(
// filter out alpha2 starting with X (not yet ISO standard)
code => code[0].substring(0, 1) !== 'X').map(code => {
  const numericString = code[2];
  const numeric = parseInt(code[2], 10);
  const alpha2 = code[0];
  const alpha3 = code[1];
  return {
    alpha2,
    alpha3,
    numeric,
    numericString,
    continent: _package.ContinentCodes[alpha2],
    name: {
      en: firstOrString(en.countries[alpha2]),
      es: firstOrString(es.countries[alpha2]),
      fr: firstOrString(fr.countries[alpha2]),
      de: firstOrString(de.countries[alpha2]),
      it: firstOrString(it.countries[alpha2]),
    }
  };
});

export { continentCodes as a, countries as c, langs as l, returnTypes as r };
